/* hs-eslint ignored failing-rules */

/* eslint-disable react/prop-types */
'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import PropTypes from 'prop-types';
import { Fragment, useState } from 'react';
import { NETWORKS_WITH_ALL, EntityTypes, ALL_NETWORKS, TrackingStatusCodes, TrackingStatusKeys } from 'AdsUI/lib/Constants';
import AdAccountRecord from 'AdsUI/records/ad-accounts/AdAccountRecord';
import TrackingStatusRecord from 'AdsUI/records/reporting/TrackingStatusRecord';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIList from 'UIComponents/list/UIList';
import I18n from 'I18n';
import TrackingStatusCell from './TrackingStatusCell';
import { toMoment } from 'UIComponents/core/SimpleDate';
import { convertTimeRangeToMessage } from 'AdsUI/lib/Utils';
import { SLINKY } from 'HubStyleTokens/colors';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import UILink from 'UIComponents/link/UILink';
import PortalIdParser from 'PortalIdParser';
import FormattedDateTime from 'I18n/components/FormattedDateTime';
import TrackingOverrideModalContainer from 'AdsUI/containers/campaign-details/TrackingOverrideModalContainer';
import { TrackingErrorReasons } from 'AdsUI/records/reporting/TrackingErrorRecord';
import { ExternalLink, FB_LEARNING_PHASE_URL, FB_SETTINGS_URL, FB_PAGE_SETTINGS_URL } from 'AdsUI/components/tracking-error-modal/TrackingErrorModalLinks';
import { AdsSimpleDateRange } from '../../lib/AdsSimpleDateRange';
const SETTINGS_URL = `/settings/${PortalIdParser.get()}/marketing/ads/leadSyncing`;
const HAS_OVERRIDE = [TrackingErrorReasons.FB_TOO_MANY_ENGAGEMENTS, TrackingErrorReasons.FB_INSTAGRAM_STORY_ENGAGEMENTS];

const TrackingStatusWithErrors = ({
  trackingStatus,
  network,
  adAccount,
  entityType,
  lastAttempted,
  openOverrideModal
}) => {
  const facebookBusinessUrl = adAccount ? `https://business.facebook.com/ads/manage/customaudiences/tos/?act=${adAccount.accountId}` : '';
  return /*#__PURE__*/_jsxs(Fragment, {
    children: [/*#__PURE__*/_jsx("p", {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: `campaigns.trackingStatus.message.${network}.${entityType}`
      })
    }), /*#__PURE__*/_jsx(UIList, {
      styled: true,
      children: trackingStatus.map(({
        reason: error
      }) => error).toSet().map(error => /*#__PURE__*/_jsxs("span", {
        children: [/*#__PURE__*/_jsx(FormattedJSXMessage, {
          message: `campaigns.trackingStatus.errors.${error}.body_jsx`,
          elements: {
            Link: ExternalLink
          },
          options: {
            network: I18n.text(network.toLowerCase()),
            adAccountName: adAccount && adAccount.accountName || '',
            facebookBusinessUrl,
            facebookLearningPhaseUrl: FB_LEARNING_PHASE_URL,
            facebookSettingsUrl: FB_SETTINGS_URL,
            facebookPageSettingsUrl: FB_PAGE_SETTINGS_URL
          }
        }), ' ', entityType === EntityTypes.AD && HAS_OVERRIDE.includes(error) && /*#__PURE__*/_jsx(UILink, {
          onClick: openOverrideModal,
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "campaigns.trackingStatus.override"
          })
        })]
      }, error))
    }), lastAttempted && /*#__PURE__*/_jsx("p", {
      children: /*#__PURE__*/_jsx(FormattedReactMessage, {
        message: "campaigns.trackingStatus.lastAttempted",
        options: {
          lastAttempted: /*#__PURE__*/_jsx(FormattedDateTime, {
            value: lastAttempted,
            format: "l",
            type: "portalTz"
          })
        }
      })
    })]
  });
};

const TrackingDisabled = ({
  children
}) => /*#__PURE__*/_jsx(TrackingStatusCell, {
  use: "disabled",
  statusKey: TrackingStatusKeys.TRACKING_OFF,
  statusInfo: /*#__PURE__*/_jsx("p", {
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "campaigns.trackingStatus.trackingDisabled"
    })
  }),
  showSettingsLink: true,
  children: children
});

const TrackingPending = ({
  children,
  network,
  entityType
}) => /*#__PURE__*/_jsx(TrackingStatusCell, {
  use: "active",
  statusKey: TrackingStatusKeys.TRACKING_PENDING,
  statusInfo: /*#__PURE__*/_jsx("p", {
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: `campaigns.trackingStatus.trackingPending.${network}.${entityType}`
    })
  }),
  children: children
});

const TrackingDateInfo = ({
  trackingEnabledMoment,
  daysTracked,
  timeRange
}) => /*#__PURE__*/_jsxs(UIList, {
  styled: true,
  children: [daysTracked ? /*#__PURE__*/_jsxs("div", {
    children: [/*#__PURE__*/_jsx(FormattedMessage, {
      message: "campaigns.trackingStatus.trackingEnabled.since",
      options: {
        trackingDate: trackingEnabledMoment.format('l')
      }
    }), /*#__PURE__*/_jsxs("span", {
      style: {
        color: SLINKY
      },
      children: [' - ', /*#__PURE__*/_jsx(FormattedMessage, {
        message: "campaigns.trackingStatus.trackingEnabled.daysAgo",
        options: {
          count: daysTracked
        }
      })]
    })]
  }) : /*#__PURE__*/_jsx(FormattedMessage, {
    message: "campaigns.trackingStatus.trackingEnabled.zeroDaysAgo"
  }), /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(FormattedMessage, {
      message: "campaigns.trackingStatus.filteredDateRange"
    }), convertTimeRangeToMessage(timeRange)]
  })]
});

const TrackingLimited = ({
  daysTracked,
  trackingEnabledMoment,
  timeRange,
  children
}) => /*#__PURE__*/_jsx(TrackingStatusCell, {
  use: "active",
  statusKey: TrackingStatusKeys.TRACKING_LIMITED,
  statusInfo: /*#__PURE__*/_jsxs("span", {
    children: [/*#__PURE__*/_jsx("p", {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "campaigns.trackingStatus.trackingLimited"
      })
    }), /*#__PURE__*/_jsx(TrackingDateInfo, {
      daysTracked: daysTracked,
      trackingEnabledMoment: trackingEnabledMoment,
      timeRange: timeRange
    })]
  }),
  children: children
});

const LeadGenTracking = ({
  children,
  network
}) => /*#__PURE__*/_jsx(TrackingStatusCell, {
  use: "active",
  statusKey: TrackingStatusKeys.LEAD_GEN,
  statusInfo: /*#__PURE__*/_jsx("p", {
    children: /*#__PURE__*/_jsx(FormattedJSXMessage, {
      message: `campaigns.trackingStatus.leadGenTracking.${network}_jsx`,
      elements: {
        Link: UILink
      },
      options: {
        external: true,
        href: SETTINGS_URL
      }
    })
  }),
  children: children
});

const TrackingStatusBody = ({
  adAccount,
  trackingStatus,
  entityType,
  network,
  children,
  disabled,
  isLeadGen,
  isTrackingEnabled,
  timeRange,
  openOverrideModal
}) => {
  if (disabled || network === ALL_NETWORKS || entityType === EntityTypes.KEYWORD) {
    return children;
  }

  if (isLeadGen) {
    return /*#__PURE__*/_jsx(LeadGenTracking, {
      network: network,
      children: children
    });
  }

  if (!isTrackingEnabled) {
    return /*#__PURE__*/_jsx(TrackingDisabled, {
      children: children
    });
  }

  if (trackingStatus.code === TrackingStatusCodes.NOT_APPLICABLE) {
    return children;
  }

  if (trackingStatus.statuses.size > 0) {
    return /*#__PURE__*/_jsx(TrackingStatusCell, {
      use: "warning",
      statusKey: TrackingStatusKeys.ALERT,
      statusInfo: /*#__PURE__*/_jsx(TrackingStatusWithErrors, {
        trackingStatus: trackingStatus.statuses,
        network: network,
        adAccount: adAccount,
        entityType: entityType,
        lastAttempted: entityType === EntityTypes.AD && trackingStatus.lastAttempted,
        openOverrideModal: openOverrideModal
      }),
      children: children
    });
  }

  if (trackingStatus.code === TrackingStatusCodes.UNTRACKED) {
    return /*#__PURE__*/_jsx(TrackingPending, {
      network: network,
      entityType: entityType,
      children: children
    });
  } // TODO: Use the actual tracking enabled date once it's available to us


  const trackingEnabledMoment = new I18n.moment(adAccount.trackingSince);
  const daysTracked = I18n.moment().diff(trackingEnabledMoment, 'days');
  const timeRangeBeginning = toMoment(timeRange.startDate);
  const timeRangeDays = timeRangeBeginning.diff(trackingEnabledMoment, 'days');

  if (timeRangeDays < 0) {
    return /*#__PURE__*/_jsx(TrackingLimited, {
      daysTracked: daysTracked,
      trackingEnabledMoment: trackingEnabledMoment,
      timeRange: timeRange,
      children: children
    });
  }

  return /*#__PURE__*/_jsx(TrackingStatusCell, {
    use: "active",
    statusKey: TrackingStatusKeys.TRACKING_ENABLED,
    statusInfo: /*#__PURE__*/_jsx(TrackingDateInfo, {
      daysTracked: daysTracked,
      trackingEnabledMoment: trackingEnabledMoment,
      timeRange: timeRange
    }),
    children: children
  });
};

const TrackingStatus = (_ref) => {
  let {
    entity
  } = _ref,
      props = _objectWithoutPropertiesLoose(_ref, ["entity"]);

  const [overrideModalOpen, setOverrideModalOpen] = useState(false);
  const {
    trackingStatus
  } = props;
  return /*#__PURE__*/_jsxs(Fragment, {
    children: [/*#__PURE__*/_jsx(TrackingStatusBody, Object.assign({}, props, {
      openOverrideModal: () => setOverrideModalOpen(true)
    })), overrideModalOpen && /*#__PURE__*/_jsx(TrackingOverrideModalContainer, {
      entity: entity,
      closeModal: () => setOverrideModalOpen(false),
      isInstagram: trackingStatus && trackingStatus.statuses.find(error => error.reason === TrackingErrorReasons.FB_INSTAGRAM_STORY_ENGAGEMENTS),
      isTrackingErrorsModal: false
    })]
  });
};

TrackingStatus.propTypes = {
  trackingStatus: PropTypes.instanceOf(TrackingStatusRecord),
  adAccount: PropTypes.instanceOf(AdAccountRecord),
  entityType: PropTypes.oneOf(Object.values(EntityTypes)),
  network: PropTypes.oneOf(NETWORKS_WITH_ALL).isRequired,
  children: PropTypes.node.isRequired,
  disabled: PropTypes.bool,
  timeRange: PropTypes.instanceOf(AdsSimpleDateRange).isRequired
};
export default TrackingStatus;